import { isCognitoEnabled } from '../../constants/featureFlag';
import authZeroScreen from '../../hoc/authZeroScreen';
import cognitoScreen from '../../hoc/cognitoScreen';

const authScreen = isCognitoEnabled ? cognitoScreen : authZeroScreen;

export default function wrapRoutesWithAuthorizationCheck(routes) {
  return Object.entries(routes)
    .map(([routeName, routeSetting]) => {
      if (routeSetting.screen) {
        return [
          routeName,
          {
            ...routeSetting,
            screen: authScreen(routeSetting.screen, routeSetting.permission),
          },
        ];
      }

      return [routeName, authScreen(routeSetting)];
    })
    .reduce(
      (attachedRoutes, [routeName, routeSetting]) => ({
        ...attachedRoutes,
        [routeName]: routeSetting,
      }),
      {}
    );
}
